export const calculateCourseState = (statusForScoreRelevantLessons, masteryScore) => {
    const completed = (statusForScoreRelevantLessons.scoAmount === 0) || ((statusForScoreRelevantLessons.scoAmount > 0) && (statusForScoreRelevantLessons.completed >= statusForScoreRelevantLessons.scoAmount));
    const score = calculateScore(statusForScoreRelevantLessons);
    const scoreSucceeded = (score >= masteryScore);
    const passed = statusForScoreRelevantLessons.scoAmount > 0 && scoreSucceeded;
    const failed = statusForScoreRelevantLessons.scoAmount > 0 && !scoreSucceeded && completed;
    return {
        score,
        passed,
        failed,
        completed
    };
};
function calculateScore(lessons) {
    if (lessons.passed === 0) {
        return 0;
    }
    return Math.round((lessons.passed / lessons.scoAmount) * 100);
}
